"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var delay = function delay(time) {
  return new Promise(function (resolve) {
    setTimeout(resolve, time);
  });
};

var Contraction = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Contraction, _React$PureComponent);

  function Contraction() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      isShow: _this.props.isShow,
      height: 'auto',
      isMeasure: false
    });

    _defineProperty(_assertThisInitialized(_this), "expansion", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _this$container$getBo, height;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.awaitSetState({
                isMeasure: true
              });

            case 2:
              _this$container$getBo = _this.container.getBoundingClientRect(), height = _this$container$getBo.height;
              _context.next = 5;
              return _this.awaitSetState({
                isShow: true,
                height: 0,
                isMeasure: false
              });

            case 5:
              _context.next = 7;
              return delay(1);

            case 7:
              _context.next = 9;
              return _this.awaitSetState({
                height: height
              });

            case 9:
              _context.next = 11;
              return delay(100);

            case 11:
              _this.setState({
                height: 'auto'
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "contraction", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var _this$container$getBo2, height;

      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$container$getBo2 = _this.container.getBoundingClientRect(), height = _this$container$getBo2.height;
              _context2.next = 3;
              return _this.awaitSetState({
                height: height
              });

            case 3:
              _context2.next = 5;
              return delay(1);

            case 5:
              _context2.next = 7;
              return _this.awaitSetState({
                height: 0
              });

            case 7:
              _context2.next = 9;
              return delay(100);

            case 9:
              _this.setState({
                isShow: false
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "awaitSetState", function (data) {
      return new Promise(function (resolve) {
        _this.setState(data, resolve);
      });
    });

    return _this;
  }

  var _proto = Contraction.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var isShow = this.props.isShow;

    if (!isShow) {
      this.contraction();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var isShow = this.props.isShow;
    var prevIsShow = prevProps.isShow;

    if (isShow !== prevIsShow) {
      if (isShow) {
        this.expansion();
      } else {
        this.contraction();
      }
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$state = this.state,
        height = _this$state.height,
        isShow = _this$state.isShow,
        isMeasure = _this$state.isMeasure;
    var style = {
      height: height,
      transition: 'height 0.1s ease-in-out',
      overflow: 'hidden'
    };

    if (isMeasure) {
      style.position = 'absolute';
      style.visibility = 'hidden';
      style.height = 'auto';
      style.width = '100%';
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      style: style,
      ref: function ref(me) {
        return _this2.container = me;
      }
    }, this.props.children);
  };

  return Contraction;
}(_react["default"].PureComponent);

var _default = Contraction;
exports["default"] = _default;
module.exports = exports.default;